import {
  DefaultContextMenu,
  DefaultContextMenuContent,
  TldrawUiMenuGroup,
  TldrawUiMenuItem,
  TLUiContextMenuProps,
} from "tldraw"
import { MoveToLayerMenu } from "./MoveToLayerMenu"

export function LDContextMenu(props: TLUiContextMenuProps) {
  return (
    <DefaultContextMenu {...props}>
      <TldrawUiMenuGroup id="example">
        <div>
          <MoveToLayerMenu />
        </div>
      </TldrawUiMenuGroup>

      <DefaultContextMenuContent />
    </DefaultContextMenu>
  )
}
